/* eslint-disable react-hooks/exhaustive-deps */
import Field from "../../shared/forms/Field";
import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import Filters from "../../shared/forms/FormFilter/Filters";
import FormMultiSelect from "../../shared/forms/FormFields/FormMultiSelect";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import React, {useEffect, useState} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../../catalogos/constantes";
import useApiInventariosCaja from "../../api/taller/useApiInventariosCaja";
import useForm from "../../shared/forms/useForm";
import {
    AgIsoDateFormatter,
    AgIsoUtcDateTimeFormatter
} from "../../shared/ag-grid-helper/GridFormatters";
import {ExportRenderer, ViewRenderer} from "../../shared/Grid/GridCellRenderers";
import InventarioCajaDetalle from "./InventarioCajaDetalle";
import _ from "lodash";
import CargadaCheckBoxRenderer from "./CargadaCheckBoxRenderer";
import SubirInventario from "./SubirInventario";
import "./InventarioCajaStyle.css";
const filtroInicial = {};
 const useResponsive = () => {
        const obtenerResolucion = () => {
            const ancho = window.innerWidth;

            return {
                isMobile: ancho <= 767,
                isTablet: ancho >= 768 && ancho <= 1199
            };
        };

        const [resolucion, setResolucion] = useState(obtenerResolucion);

        useEffect(() => {
            const actualizarResolucion = () => {
                setResolucion(obtenerResolucion());
            };

            window.addEventListener("resize", actualizarResolucion);

            return () => {
                window.removeEventListener("resize", actualizarResolucion);
            };
        }, []);

        return resolucion;
    };

const InventariosCaja = () => {
    const api = useApiInventariosCaja();
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantes.menus.inventariosCaja);
    const [datos, setDatos] = useState([]);
    const [geocercas, setGeocercas] = useState([])
    const [estados, setEstados] = useState([])
    const [municipios, setMunicipios] = useState([])
    const [estatus, setEstatus] = useState([])
    const [id, setId] = useState(null)
    const [visibleSubir, setVisibleSubir] = useState(false)
    const permisoEnTaller = seguridad.tieneAcceso(constantes.opciones.permisoEnTaller);
    const {isMobile, isTablet} = useResponsive();
    const {values: filter, onChange: onFilterChange, onClear} = useForm(filtroInicial);

    const filtrar = async (filtro) => {
        setDatos([]);
        const cargada = filtro.cargadaVacia === 'cargada' ? true : filtro.cargadaVacia === 'vacia' ? false : null;
        let datos = await api.filtrar({...filtro,cargada});

        let nuevasGeocercas = _.sortBy([...new Set(datos.map(item => item.geocerca))], e => e);
        let nuevosEstados = _.sortBy([...new Set(datos.map(item => item.estado))], e => e);
        let nuevosMunicipios = _.sortBy([...new Set(datos.map(item => item.municipio))], e => e);
        let nuevosEstatus = _.sortBy([...new Set(datos.map(item => item.estatus))], e => e);
        if ((filtro?.estados?.length ??0) === 0 || nuevosEstados.length > estados.length) {
            setEstados(nuevosEstados.map(e=>({id:e, nombre:e})));
        }
        if ((filtro?.municipios?.length??0) === 0 || nuevosMunicipios.length > municipios.length) {
            setMunicipios(nuevosMunicipios.map(e => ({id: e, nombre: e})));
        }
        if ((filtro?.geocercas?.length??0) === 0 || nuevasGeocercas.length > geocercas.length){
            setGeocercas(nuevasGeocercas.map(e=>({id:e, nombre:e})));
        }
        if ((filtro?.estatus?.length??0) === 0 || nuevosEstatus.length > estatus.length){
            setEstatus(nuevosEstatus.map(e=>({id:e, nombre:e})));
        }
        setDatos(datos);
    }

    useEffect(() => {
        filtrar(filter).then();
    }, []);

    const handleFilter = async (filtro) => {
        await filtrar(filtro);
    }

    const onExport = async () => {
        await api.excel(filter).then();
    }

    const onSaved = async () => {
        await filtrar(filter);
        setId(null);
        setVisibleSubir(false);
    }
   

   return (
    <div className="main-screen inventario-cajas-screen">

        <div className="inventario-cajas-filtros">
            <FormFilter
                columns={isMobile ? 1 : isTablet ? 3 : 9}
                filter={filter}
                onChange={onFilterChange}
                onClear={onClear}
                onFilter={handleFilter}
            >
                <Filters>
                    <Field
                        label="Estados"
                        field="estados"
                        options={estados}
                        render={FormMultiSelect}
                    />

                    <Field
                        label="Municipios"
                        field="municipios"
                        options={municipios}
                        render={FormMultiSelect}
                    />

                    <Field
                        label="Geocercas"
                        field="geocercas"
                        options={geocercas}
                        render={FormMultiSelect}
                    />

                    <Field
                        label="Patios"
                        field="patioIds"
                        source="patios"
                        render={FormMultiSelect}
                    />

                    <Field
                        label="Cajas"
                        field="cajas"
                        render={FormTextBox}
                    />

                    <Field
                        label="Estatus"
                        field="estatus"
                        options={estatus}
                        render={FormMultiSelect}
                    />

                    <Field
                        label="Cargada/Vacía"
                        field="cargadaVacia"
                        options={constantes.cargadaVaciaOptions}
                        showClear={true}
                        render={FormDropDown}
                    />

                    <Field
                        label="Unidad de Negocio"
                        field="unidadNegocioId"
                        source="unidadesNegocio"
                        showClear={true}
                        render={FormDropDown}
                    />
                </Filters>

                <Buttons filter={true} clear={true}>
                    <button
                        type="button"
                        onClick={() => setVisibleSubir(true)}
                        disabled={!permisoEnTaller}
                        className="btn btn-sm btn-outline-primary boton-subir-inventario"
                    >
                        Subir Inventario
                    </button>
                </Buttons>
            </FormFilter>
        </div>

        <div className="divider"/>

        <div
            className={`ag-theme-balham grid-principal cell-flex inventario-cajas-grid ${
                isMobile
                    ? "inventario-cajas-grid-mobile"
                    : isTablet
                        ? "inventario-cajas-grid-tablet"
                        : ""
            }`}
        >
            <AgGridReact
                key={
                    isMobile
                        ? "grid-mobile"
                        : isTablet
                            ? "grid-tablet"
                            : "grid-desktop"
                }
                rowSelection="single"
                enableSorting={true}
                enableFilter={!isMobile}
                pagination={true}
                paginationPageSize={isMobile ? 15 : isTablet ? 25 : 50}
                rowData={datos}
                defaultColDef={{
                    sortable: true,
                    resizable: !isMobile,
                    suppressMovable: isMobile
                }}
                getRowId={(params) => params.data.id}
                overlayLoadingTemplate={agGridHelper.loadingOverlay}
                gridOptions={{
                    suppressRowClickSelection: true,
                    suppressCellSelection: true,
                    suppressHorizontalScroll: false
                }}
                rowHeight={isMobile ? 40 : 35}
                headerHeight={isMobile ? 42 : 35}
                context={{
                    onExport: onExport,
                    viewDetail: (id) => {
                        setId(id);
                    }
                }}
            >
                {/* Siempre visible */}
                <AgGridColumn
                    width={isMobile ? 95 : 100}
                    minWidth={isMobile ? 95 : 100}
                    field="numeroEconomico"
                    headerName="Caja"
                    pinned={isMobile ? "left" : null}
                    lockPinned={isMobile}
                    cellClass="center"
                />

                {/* Siempre visible */}
                <AgGridColumn
                    width={isMobile ? 145 : 170}
                    minWidth={130}
                    field="patio"
                    headerName="Patio"
                />

                {/* Siempre visible */}
                <AgGridColumn
                    width={isMobile ? 190 : undefined}
                    minWidth={isMobile ? 190 : 200}
                    flex={isMobile ? undefined : 1}
                    field="geocerca"
                    headerName="Geocerca"
                />

                {/* Tablet y escritorio */}
                <AgGridColumn
                    hide={isMobile}
                    width={90}
                    field="cargada"
                    headerName="Cargada"
                    cellRenderer={CargadaCheckBoxRenderer}
                />

                <AgGridColumn
                    hide={isMobile}
                    width={90}
                    field="enTaller"
                    headerName="En Taller"
                    cellRenderer={CargadaCheckBoxRenderer}
                />

                {/* Siempre visible */}
                <AgGridColumn
                    width={isMobile ? 115 : 100}
                    field="estatus"
                    headerName="Estatus"
                />

                {/* Tablet y escritorio */}
                <AgGridColumn
                    hide={isMobile}
                    width={120}
                    field="ultimaCartaPorte"
                    headerName="Última Carta Porte"
                />

                <AgGridColumn
                    hide={isMobile}
                    width={135}
                    field="fechaInicioUltimoViaje"
                    headerName="Fecha Último Viaje"
                    valueFormatter={AgIsoDateFormatter}
                />

                <AgGridColumn
                    hide={isMobile}
                    width={125}
                    field="diasSinMovimiento"
                    headerName="Días sin Movimiento"
                />

                <AgGridColumn
                    hide={isMobile}
                    width={110}
                    field="diasCargados"
                    headerName="Días Cargados"
                />

                {/* En móvil se oculta */}
                <AgGridColumn
                    hide={isMobile}
                    minWidth={200}
                    flex={1}
                    field="ultimoCliente"
                    headerName="Último Cliente"
                />

                {/* Solo escritorio */}
                <AgGridColumn
                    hide={isMobile || isTablet}
                    width={150}
                    field="fechaActualizacionGps"
                    headerName="Actualización GPS"
                    valueFormatter={AgIsoUtcDateTimeFormatter}
                />

                <AgGridColumn
                    hide={isMobile || isTablet}
                    width={120}
                    field="dias"
                    headerName="Días sin Actualizar"
                />

                <AgGridColumn
                    hide={isMobile || isTablet}
                    width={90}
                    field="pais"
                    headerName="País"
                />

                {/* Tablet y escritorio */}
                <AgGridColumn
                    hide={isMobile}
                    width={130}
                    field="estado"
                    headerName="Estado"
                />

                <AgGridColumn
                    hide={isMobile}
                    width={160}
                    field="municipio"
                    headerName="Municipio"
                />

                {/* Solo escritorio */}
                <AgGridColumn
                    hide={isMobile || isTablet}
                    width={170}
                    field="unidadNegocioNombre"
                    headerName="Unidad de Negocio"
                />

                <AgGridColumn
                    hide={isMobile || isTablet}
                    minWidth={300}
                    flex={2}
                    field="ultimaUbicacion"
                    headerName="Última Ubicación"
                />

                {/* Siempre visible a la derecha */}
                <AgGridColumn
                    width={isMobile ? 58 : 60}
                    minWidth={isMobile ? 58 : 60}
                    maxWidth={isMobile ? 58 : 60}
                    headerName="VER"
                    pinned="right"
                    lockPinned={true}
                    suppressSizeToFit={true}
                    headerComponent={ExportRenderer}
                    cellRenderer={ViewRenderer}
                    path="/comercial/editar_cotizacion/"
                />
            </AgGridReact>
        </div>

        <InventarioCajaDetalle
            id={id}
            disabled={soloLectura}
            onCancel={() => setId(null)}
            onSaved={onSaved}
        />

        <SubirInventario
            onSaved={onSaved}
            visible={visibleSubir}
            onCancel={() => setVisibleSubir(false)}
        />
    </div>
);
}

export default InventariosCaja;